module.exports = __webpack_public_path__ + "79b90bba200a564a63febd6a4b5384f3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-reggae.png
// module id = 2747
// module chunks = 0